import { Button } from '../../../../../../components/buttons/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '../../../../../../components/dialog';
import { tGlobal, tNamespace } from '../../../../../../services/translation';

const t = tNamespace('app.settings.organization.users');

type UserDeleteUserDialogProps = {
  dialogDeleteState: boolean;
  setDialogDeleteState: (state: boolean) => void;
  isLoading: boolean;
  deleteUser: () => void;
};

export function UserDeleteUserDialog(props: UserDeleteUserDialogProps) {
  const { dialogDeleteState, setDialogDeleteState, isLoading, deleteUser } = props;
  return (
    <Dialog open={dialogDeleteState} onOpenChange={setDialogDeleteState}>
      <DialogContent hasCloseButton>
        <div>
          <DialogTitle>{t('deleteUser')}</DialogTitle>
          <DialogDescription>{t('deleteUserDescription')}</DialogDescription>
          <DialogFooter isColumn>
            <Button
              loading={isLoading}
              size="xl"
              variant="outline"
              className="flex-1"
              onClick={function () {
                setDialogDeleteState(false);
              }}
            >
              {tGlobal('cancel')}
            </Button>

            <Button
              loading={isLoading}
              size="xl"
              variant="destructive"
              className="flex-1"
              onClick={function () {
                void deleteUser();
              }}
            >
              {t('yesDeleteUser')}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
